<mat-expansion-panel #panel class="custom-mat-expansion-panel" [expanded]="view.expanded" *ngIf="[] as countArray">
    <mat-expansion-panel-header [collapsedHeight]="HeaderHeight" style="padding: 0;">
        <div class="card-header">
            <fa-icon *ngIf="view.headlineIcon || InvoiceEditorMeta.Icon as icon" class="icon" [icon]="icon"></fa-icon>
            <h3>
                {{ view.headline || 'Dokumente' }}<span *ngIf="countArray.length"> ({{ ArraySum(countArray) }})</span>
            </h3>
            <div class="header-button-container">
                <button *ngIf="panel.expanded" app-round-button matTooltip="Zus. Spalten anzeigen" (click)="$event.stopPropagation()" [matMenuTriggerFor]="toggleColumnMenu">
                    <fa-icon icon="table-columns"></fa-icon>
                </button>
                <!--                <ng-container *ngIf="headerButtonTemplate" [ngTemplateOutlet]="headerButtonTemplate"></ng-container>-->
                <button app-round-button matTooltip="Dokument erstellen" matTooltipPosition="left" (click)="NewReport(); $event.stopPropagation();" *ngIf="PS.Has$(PS.Permissions.CreateLedgerImports) | async">
                    <app-double-icon [Icon]="ReportsPageMeta.Icon" Icon2="plus"></app-double-icon>
                </button>
            </div>
        </div>
    </mat-expansion-panel-header>
    <mat-tab-group (selectedIndexChange)="onTabIndexChange($event)">
        <mat-tab *ngFor="let types of ledgerImportListData$ | async; index as index" [label]="getMatGroupTitle(types.documentTypeLabel, countArray[index])" #tab>
            <!--                <ng-container [ngTemplateOutlet]="GetTemplateByType(childView.type)" [ngTemplateOutletContext]="{ view: childView, index, countArray, tab }"></ng-container>-->
            <app-dave-list-card
                (Count)="countArray ? (countArray[index] = $event) : null"
                [Headline]="types.documentTypeLabel"
                [HeaderIcon]="InvoiceEditorMeta.Icon"
                [EmptyText]="'Keine ' + types.documentTypeLabel + ' vorhanden'"
                [Data]="types.ListCardData$ | async"
                [HasSuffixButton]="ShowDocumentButton"
                [DisplayedCollums]="types.displayedColumns$ | async"
                [TableHeaderCollumsMap]="getTableHeaderCollumsMap(types)"
                [Clickable]="true"
                [Multiselect]="multiselectAvailable"
                [MultiselectButtons]="MultiselectButtons$ | async"
                [GetRouterLinkFunction]="NavigateOnClick ? GetRouteForLedgerImport : null"
                [IsExpandable]="true"
                [Expanded]="true"
                [DefaultSortActive]="DefaultSortActive"
                [DefaultSortDirection]="DefaultSortDirection"
                (EntryClicked$)="LedgerImportClick.emit($event)"
                (MultiselectedEntryIdsChange)="getSelectedData($event)"
                style="max-height: 50vh"
            >
                <!-- Multiselect Status Form -->
                <app-detail-list-template
                    headerMultiselectButton
                    *ngIf="showStatus && selectedEntryIds?.length"
                    [Inline]="true"
                    [Editing]="true"
                    [Data]="StatusData$ | async"
                    style="margin: -1rem;"
                ></app-detail-list-template>
                <!-- Multiselect Status Button -->
                <button
                    headerMultiselectButton
                    app-round-button
                    [Disabled]="!selectedEntryIds?.length"
                    matTooltip="Status ändern"
                    (click)="showStatus = !showStatus"
                    [IsLoading]="LS.IsLoading$ | async"
                >
                    <fa-icon [icon]="showStatus && selectedEntryIds?.length ? 'chevron-right' : 'info'"></fa-icon>
                </button>
                <!-- Create Button -->
                <button
                    headerButton
                    app-round-button
                    [matMenuTriggerFor]="types.documentTypes.length > 1 ? newInvoiceMenu : null"
                    (click)="types.documentTypes.length === 1 ? NewLedgerImportClick.emit(types.documentTypes[0].type) : {}"
                    [matTooltip]="types.documentTypeLabel + ' hinzufügen'"
                    *ngIf="PS.Has(PS.Permission.CreateLedgerImports) | async"
                >
                    <app-double-icon [Icon]="InvoiceEditorMeta.Icon" Icon2="plus"></app-double-icon>
                </button>
                <mat-menu #newInvoiceMenu="matMenu">
                    <div *ngFor="let t of types.documentTypes" [matTooltip]="t.disabledHint$ | async" [matTooltipDisabled]="(t.disabled$ | async) === false">
                        <button  mat-menu-item (click)="NewLedgerImportClick.emit(t.type)" [disabled]="(t.disabled$ | async) || (t.loading$ | async)">
                            <div class="flex items-center">
                                <app-loading style="flex-grow: 0;" class="mr-2" *ngIf="(t.disabled$ | async) === false && (t.loading$ | async)" [Size]="24"></app-loading>
                                {{ t.label }}
                                <app-hint-icon *ngIf="(t.disabled$ | async) && (t.disabledHint$ | async)" [hint]="t.disabledHint$ | async"></app-hint-icon>
                            </div>
                        </button>
                    </div>
                </mat-menu>
            </app-dave-list-card>
        </mat-tab>
    </mat-tab-group>
</mat-expansion-panel>

<mat-menu #toggleColumnMenu="matMenu">
    <ng-container *ngIf="currentOptionalColumnsVisibility$ | async as currentOptionalColumnsVisibile">
    <button mat-menu-item (click)="updateColumn('DueDate', !currentOptionalColumnsVisibile.includes('DueDate')); $event.stopPropagation()">
        {{ currentOptionalColumnsVisibile.includes('DueDate') ? 'Frist ausblenden' : 'Frist anzeigen' }}
    </button>
    <button mat-menu-item (click)="updateColumn('CreatedAt', currentOptionalColumnsVisibile.includes('CreatedAt')); $event.stopPropagation()">
        {{ currentOptionalColumnsVisibile.includes('CreatedAt') ? 'Erstellungsdatum ausblenden' : 'Erstellungsdatum anzeigen' }}
    </button>
    <button mat-menu-item (click)="updateColumn('Notes', !currentOptionalColumnsVisibile.includes('Notes')); $event.stopPropagation()">
        {{ currentOptionalColumnsVisibile.includes('Notes') ? 'Notiz ausblenden' : 'Notiz anzeigen' }}
    </button>
        <button mat-menu-item (click)="updateColumn('DocumentType', !currentOptionalColumnsVisibile.includes('DocumentType')); $event.stopPropagation()">
            {{ currentOptionalColumnsVisibile.includes('DocumentType') ? 'Dokumentenart ausblenden' : 'Dokumentenart anzeigen' }}
        </button>
    </ng-container>
</mat-menu>
